import _classCallCheck from "/Users/maximo/Desktop/tickets/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/maximo/Desktop/tickets/node_modules/@babel/runtime/helpers/esm/createClass.js";

/**
@module   fps
@desc     Frames-per-second-counter class.
@category core
*/
var FPS = /*#__PURE__*/function () {
  function FPS() {
    _classCallCheck(this, FPS);

    this.frames = 0;
    this.ptime = 0;
    this.fps = 0;
  }

  _createClass(FPS, [{
    key: "update",
    value: function update(time) {
      this.frames++;

      if (time >= this.ptime + 1000) {
        this.fps = this.frames * 1000 / (time - this.ptime);
        this.ptime = time;
        this.frames = 0;
      }

      return this.fps;
    }
  }]);

  return FPS;
}();

export { FPS as default };